import _ from 'lodash';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import AccountSwitcher from 'app/viewport/components/AccountSwitcher';
import maybeRender from 'app/common/components/maybeRender';
import { getAccountSwitcherUrl } from 'app/common/middlewares/accountSwitcherMiddleware';

// Note that `accounts` are loaded by `AccountMenu` at this time.
// This particular component mounts and unmounts when the dropdown
// menu is open and we don't want to make an API request every time
// the menu is toggled which is why `AccountMenu` loads accounts.
const mapStateToProps = (state, props) => ({
  accounts: Account.selectors.all
    .persistedEntities(state)
    .filter(
      props.shouldOnlyShowTeamAccounts ? Account.selectors.isTeam : () => true
    )
    // Always put personal account at the top. The only way to
    // differentiate a personal account from a team account is `isTeam`.
    .sort((acct1, acct2) => {
      if (!Account.selectors.isTeam(acct1)) {
        return -1;
      }
      if (!Account.selectors.isTeam(acct2)) {
        return 1;
      }
      return Account.selectors.name(acct1).toLowerCase() <
        Account.selectors.name(acct2).toLowerCase()
        ? -1
        : 1;
    })
    .map(acct => ({
      id: Account.selectors.id(acct),
      isActive: Account.selectors.isActive(state, acct),
      name: Account.selectors.teamName(acct),
    })),
  switcherUrl: getAccountSwitcherUrl(state),
});

const shouldRender = props =>
  props.accounts.length > 0 || props.shouldOnlyShowTeamAccounts;

export default _.flowRight(
  connect(mapStateToProps),
  maybeRender(shouldRender)
)(AccountSwitcher);
